// extracted by mini-css-extract-plugin
export default {"checkoutBtn":"checkoutBtn_checkoutBtn__Is9gq","selected":"checkoutBtn_selected__lVGy5"};